export const InfoType = {
    AlternativeDeliveryExteralId: "AlternativeDeliveryExternalId",
    OrderAgainFlag: "OrderAgainFlag"
}